import { showTransparentPopupAction } from 'js/components/common/popups/TransparentPopup';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';

export const showGeofencingPopupAction = ({
    useTransparentPopup,
    ...action
}: {
    useTransparentPopup: boolean;
} & Partial<Parameters<typeof showTransparentPopupAction>[0]>) => {
    if (useTransparentPopup) {
        return showTransparentPopupAction(action);
    }

    return showCommonPopupAction(action);
};
